module.exports = __webpack_public_path__ + "media/images/english_soccer-8884eb85.jpg";